import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';  // Enables routing between the components
import Home from 'components/FacilityRequestComponents/Home/Home';
import Comfort from 'components/FacilityRequestComponents/Comfort/Comfort';
import AfterHours from 'components/FacilityRequestComponents/AH/AfterHoursList';
import NoZonesMessage from 'components/FacilityRequestComponents/Shared/NoZonesMessage';
import CreateAfterHoursRequest from 'components/FacilityRequestComponents/AH/CreateAfterHoursRequest';
import ViewAfterHoursRequest from 'components/FacilityRequestComponents/AH/ViewAfterHoursRequest';
import EditAfterHoursRequest from 'components/FacilityRequestComponents/AH/EditAfterHoursRequest';
import Maintenance from 'components/FacilityRequestComponents/Maintenance/Maintenance';
import CreateMaintenance from 'components/FacilityRequestComponents/Maintenance/CreateMaintenance';
import ViewMaintenance from 'components/FacilityRequestComponents/Maintenance/ViewMaintenance';
import EditMaintenance from 'components/FacilityRequestComponents/Maintenance/EditMaintenance';
import styles from '..//Shared/shared.module.css';


export default class ReportsSubRouting extends Component {
    constructor(props){
        super(props);
        this.getActivePagefromSubRouter=this.getActivePagefromSubRouter.bind(this);
    }
    getActivePagefromSubRouter(data){      //Fetching active page name to update title bar
            this.props.onGetActivePage(data);
    }

    render() {
        return (
        <div className={styles.subroute_Container}>
            <Switch>
               <Route path={'/FacilityManagement/home'}  render={props => <Home  onGetActivePagefromSubRouter={this.getActivePagefromSubRouter}/>} />   
               <Route path={'/FacilityManagement/Comfort'} render={ props => <Comfort {...props} zoneDetails={this.props.zoneDetails} />} />   
               <Route path={'/FacilityManagement/AfterHours'} render={(props) => <AfterHours {...props} zoneDetails={this.props.zoneDetails}/>}/>   
               <Route path={'/FacilityManagement/CreateAfterHoursRequest'} render={(props) => <CreateAfterHoursRequest {...props} zoneDetails={this.props.zoneDetails}/>}/>   
               <Route path={'/FacilityManagement/ViewAfterHoursRequest'} component={ViewAfterHoursRequest}/>   
               <Route path={'/FacilityManagement/EditAfterHoursRequest'} component={EditAfterHoursRequest}/>   
               <Route path={'/FacilityManagement/Maintenance'} component={Maintenance}/>   
               <Route path={'/FacilityManagement/createMaintenance'} component={CreateMaintenance}/>   
               <Route path={'/FacilityManagement/ViewMaintenance'} component={ViewMaintenance}/>   
               <Route path={'/FacilityManagement/EditMaintenance'} component={EditMaintenance}/>   
               <Route path={'/FacilityManagement/Message'} component={NoZonesMessage}/>   
            </Switch>
        </div>  
    );
}
}